import GetLotteryResponse, { LotteryType } from '../CRM/Responses/LotteryResponse';

import Model from './Model';

import { LineNumbers } from 'components/play/Types/Types';

export default class Lottery extends Model {
    readonly id: number;
    readonly lottery_rule_id: number | null;
    readonly name: string;
    readonly type: LotteryType = 'lottery';
    readonly slug: string;
    readonly display_slug: string;
    readonly is_enabled: boolean;
    readonly is_visible_on_web: boolean;
    readonly is_default: boolean;
    readonly is_promoted: boolean;
    readonly last_draw_date: string | null;
    readonly next_draw_date: string | null;
    readonly last_numbers: LineNumbers;
    readonly timezone: string;
    readonly display_order: number = 0;
    // additional props
    readonly lottery_rule: object;

    constructor(lottery: Partial<GetLotteryResponse>) {
        super();
        this.assignDataToProps(lottery, [
            'id',
            'lottery_rule_id',
            'name',
            'type',
            'slug',
            'display_slug',
            'is_enabled',
            'is_visible_on_web',
            'is_default',
            'is_promoted',
            'last_draw_date',
            'next_draw_date',
            'last_numbers',
            'timezone',
            'display_order',
            'lottery_rule',
        ]);
    }
}
